package com.fireavert.email

object EmailValidator {
    private const val EMAIL_REGEX = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}\$"
    fun isEmailValid(email: String): Boolean {
        return EMAIL_REGEX.toRegex().matches(email.trim())
    }
}